<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" [class.disabled]="form.disabled">
  <div class="flex">
    <fcom-text-input
      class="flex-1 flex--basis0 ps-small-r"
      [parentForm]="form"
      [controlName]="'recLoc'"
      [translationPrefix]="'loginFields.recLoc'"
      [required]="false"
      [translationErrorPrefix]="'loginFields.recLoc.validationMessages'"
    ></fcom-text-input>

    <fcom-text-input
      class="flex-1 flex--basis0"
      [parentForm]="form"
      [controlName]="'lastName'"
      [translationPrefix]="'loginFields.lastName'"
      [required]="false"
      [translationErrorPrefix]="'loginFields.lastName.validationMessages'"
    ></fcom-text-input>
  </div>
  <div class="flex flex--align-start">
    <div class="flex-1 flex--basis0 flex--self-center">
      <a
        data-testid="status-checker-info-link"
        class="inline-block font-body-1 nordic-blue-900-text"
        [finLink]="'SERVICE_FORMS.serviceForms.refundStatusChecker.recloc.link.url' | finLocalization"
        [openInNewTab]="true"
        [external]="true"
        (mousedown)="$event.preventDefault()"
        >{{ 'SERVICE_FORMS.serviceForms.refundStatusChecker.recloc.text' | finLocalization }}</a
      >
    </div>

    <div class="flex-1 flex--basis0 align-right">
      <fcom-button
        [loading]="loading"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [icon]="loading ? { name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT } : undefined"
        [text]="'SERVICE_FORMS.serviceForms.refundStatusChecker.ctaButtonText' | finLocalization"
        [type]="ButtonType.SUBMIT"
        [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      >
      </fcom-button>
    </div>
  </div>
  <fcom-notification *ngIf="checkFailed" class="ps-medium-t" [theme]="NotificationTheme.ALERT">
    {{ 'SERVICE_FORMS.serviceForms.refundStatusChecker.notFound' | finLocalization }}
  </fcom-notification>
</form>
